import { MY_ACCOUNT_SHOPPING_LISTS_URL } from 'features/my-account/routes.commerce';
import React from 'react';
import { Localizer } from 'services/Localizer';
import { useShoppingListLoader } from '../my-account/shopping-lists/useShoppingListLoader';

interface ProductListsProps {
	productId: string;
}

export default function ProductLists(props: ProductListsProps) {
	const { results } = useShoppingListLoader({
		productId: props.productId,
	});
	return (
		<>
			{/* #region HCL */}
			{results && results.results && results.results.length > 0 ? (
				<>
					<h3>{Localizer('DisplayListsLabel')}</h3>
					<ul className="roc-utlity-nav__menu">
						{results &&
							results.results &&
							results.results.map((shoppingList, index) => {
								return (
									<li className="roc-utlity-nav__menu-item" key={index}>
										<button
											className="roc-utlity-nav__menu-item-link"
											onClick={() =>
												(window.location.href = `${MY_ACCOUNT_SHOPPING_LISTS_URL}/${shoppingList.id}`)
											}
										>
											{shoppingList.name}
										</button>
									</li>
								);
							})}
					</ul>
				</>
			) : null}
			{/* #endregion */}
		</>
	);
}
